export default "__VITE_ASSET__D7Zltv3U__"